module.exports = __webpack_public_path__ + "img/pay-logo-alipay.6977fb63.png";